/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import ToggleSwitchComponent from "@CubeComponents/form/ToggleSwitchComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_ERROR } from "@Services/constants";
import { getOrgTypes, getOrgstructureData } from "@Actions/orgStructure";
import { getProjectObject } from "@Actions/projectSetting";
import { updateProjectRules } from "@Actions/projectRules";
import QueryBuilderComponent from "@CubeComponents/html/queryBuilder";
import { RootState } from "@Reducers/index";
import type { ProjectRoleItem } from "@ServerTypes/projects/project.schema";
import type { OrgStructureNameIdEntry } from "@ServerTypes/orgUnits/orgUnits.schema";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

function AddRule({ data = [], closeModalPopup, defaultRule, handleBackClick }: any) {
  const { t } = useTranslation();
  const queryBuilderRef: any = useRef<any>(null);
  const [ruleName, setRuleName] = useState("");
  const roleData = useSelector((state: RootState) => state.roleData as ProjectRoleItem[]);
  const [selectedRole, setSelectedRole] = useState("");
  const [keepProjectRole, setKeepProjectRole] = useState(false);
  const [removeUser, setRemoveUser] = useState(false);
  const [ruleAdded, setRuleAdded] = useState(false);

  const params = useParams();
  const userDetails = useSelector((state: RootState) => state.userDetails);
  const portalData = useSelector((state: RootState) => state.portalData);
  const orgStructureData = useSelector((state: RootState) => state.orgStructureData);
  const dispatch = useDispatch();

  const init = async () => {
    if (data.length) {
      setRuleName(data[0].name);
      setSelectedRole(data[0].roleId);
      setKeepProjectRole(data[0].keepProjectRole != 0);
      setRemoveUser(data[0].removeUser != 0);
      setRuleAdded(true);
    }
    if (defaultRule) {
      setKeepProjectRole(true);
      setRuleAdded(true);
    }

    if (roleData) {
      roleData.map((role: any) => {
        if (role.frontendName == "Viewer") {
          setSelectedRole(role.id);
        }
      });
    }

    if (Object.keys(orgStructureData).length <= 1) {
      // Redux models `organisation` as optional (the slice's initialState is `{}`), so the id is
      // asserted once here; the backend route schema rejects a missing/malformed orgId.
      const orgId = userDetails.organisation?.id as ObjectIdString;
      const data = {
        value: {
          orgId,
          where: [
            {
              field: "parentId",
              isComplex: false,
              operator: "equal",
              value: null,
            },
          ],
        },
      };
      dispatch(getOrgstructureData(data));
    }
  };

  useEffect(() => {
    init();
  }, []);

  const handlePopUpAction = async () => {
    const actionData: any = {
      role: selectedRole,
      removeUser,
      keepProjectRole,
      projectId: params.projectId,
      portalId: portalData.id,
    };

    if (defaultRule) {
      actionData.ruleData = defaultRule;
      actionData.action = "insert";
    } else {
      let queryRule = queryBuilderRef.current.getValidRules(queryBuilderRef.current.rule);
      queryRule = JSON.stringify(queryRule);

      actionData.name = ruleName;
      actionData.ruleData = queryRule;

      if (!data.length) {
        actionData.action = "insert";
      } else {
        actionData.action = "update";
        actionData.id = data[0].id;
      }
    }

    const response = (await updateProjectRules(actionData)) as any;
    if (response.data.status && params.projectId) {
      closeModalPopup();
      dispatch(getProjectObject({ id: params.projectId }));
    } else {
      dispatch(
        showToastNotification({
          content: response.data.errorMessage,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const customOperators = [
    { key: "Starts With", value: "startswith" },
    { key: "Ends With", value: "endswith" },
    { key: "Contains", value: "contains" },
    { key: "Equal", value: "equal" },
    { key: "Not Equal", value: "notequal" },
  ];
  const emailOperators = [{ key: "Equal", value: "equal" }];

  const customOperatorsForOrgTypes = [{ key: "Equal", value: "equal" }];

  const handleDropDownChange = (params: any) => {
    queryBuilderRef.current.notifyChange(params.target.value, params.target.element, "value");
  };

  const dropDownTemplate = (args: any) => {
    const dropdownDataSource =
      (orgStructureData[orgStructureData[args.field] as string] as OrgStructureNameIdEntry[]) || [];

    return (
      <AutoComplete
        options={dropdownDataSource}
        valueField="id"
        getOptionLabel={(option: any) => option?.name || ""}
        value={dropdownDataSource.find((opt: any) => opt.id === args.rule.value) || null}
        onChange={(_event: any, newValue: any) =>
          handleDropDownChange({ target: { value: newValue?.id, element: args.element } })
        }
        renderInput={(params: any) => <TextFieldComponent {...params} placeholder={t("Select Value")} />}
      />
    );
  };

  const createdControl = async () => {
    const QueryBuilderColumns: any = [
      {
        field: "firstName",
        label: "FirstName",
        type: "string",
        operators: customOperators,
      },
      {
        field: "lastName",
        label: "LastName",
        type: "string",
        operators: customOperators,
      },
      {
        field: "designation",
        label: "Designation",
        type: "string",
        operators: customOperators,
      },
      {
        field: "email",
        label: "Email",
        type: "string",
        operators: emailOperators,
      },
    ];

    const orgTypesResponse: any = await getOrgTypes();
    if (orgTypesResponse.data.status) {
      orgTypesResponse.data.result.map((typeData: any) => {
        QueryBuilderColumns.push({
          field: typeData.id,
          label: typeData.name,
          type: "string",
          template: dropDownTemplate,
          operators: customOperatorsForOrgTypes,
        });
      });
    }
    queryBuilderRef.current.columns = QueryBuilderColumns;
    if (data.length) {
      queryBuilderRef.current.setRules(JSON.parse(data[0].ruleData));
    }
    if (defaultRule) {
      queryBuilderRef.current.setRules(JSON.parse(defaultRule));
    }
  };

  const ruleValueChangeHandler = (args: any) => {
    if (args.type == "value") {
      if (args.value.trim() != "") {
        setRuleAdded(true);
      } else if (args.value.trim() == "") {
        if (args.value == "" && queryBuilderRef.current.getValidRules(queryBuilderRef.current.rule).rules) {
          setRuleAdded(true);
        } else {
          setRuleAdded(false);
        }
      }
    } else if (args.type == "deleteRule") {
      const ruleData = queryBuilderRef.current.getValidRules(queryBuilderRef.current.rule);
      if (!ruleData.rules || (ruleData.rules.length == 1 && ruleData.rules[0].value.trim() == "")) {
        setRuleAdded(false);
      } else {
        setRuleAdded(true);
      }
    }
  };

  const ruleNameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRuleName(e.target.value);
  };

  const handleRuleChange = (event: any) => {
    setSelectedRole(event.value);
  };

  const handleKeepUserToggle = () => {
    setKeepProjectRole((prev: any) => !prev);
  };

  const handleRemoveUserToggle = () => {
    setRemoveUser((prev: any) => !prev);
  };

  const selectedRoleName = () => {
    const roleDetails = roleData.find((role: any) => role.id == selectedRole);
    return roleDetails?.frontendName;
  };

  const modelContentData = () => (
    <div>
      <div className={`flex items-center gap-5 pb-[1.875rem] ${defaultRule ? "ms-[-1.875rem]" : ""}`}>
        {defaultRule && (
          <div className="flex h-[1.875rem] w-[1.875rem] items-center justify-center rounded-full bg-[var(--button-light)]">
            <span className="text-[var(--primary-text)]">2</span>
          </div>
        )}
        <div className="text-lg font-semibold text-[var(--primary-text)]">
          {t("Create rule to add users to this project")}
        </div>
      </div>

      {!defaultRule && (
        <div className="mb-7 flex items-center gap-[1.125rem]">
          <div className="text-sm text-[var(--primary-text)]">{t("Rule Name")}</div>
          <div>
            <TextFieldComponent
              placeholder={t("Rule Name")}
              width="18.75rem"
              onChange={ruleNameChangeHandler}
              value={ruleName}
            />
          </div>
        </div>
      )}
      <div className="text-sm text-[var(--primary-text)]">
        {t("Automatically attach users which match the below criteria")}
      </div>
      <div className="relative mt-6 mb-10">
        <div className={`max-h-[12.5rem] overflow-auto ${defaultRule ? "opacity-50" : ""}`}>
          {Object.keys(orgStructureData).length > 1 && (
            <QueryBuilderComponent
              ref={queryBuilderRef}
              created={createdControl}
              width="100%"
              change={ruleValueChangeHandler}
              showButtons={{ groupInsert: false }}
            />
          )}
        </div>
        {defaultRule && <div className="absolute inset-0 h-full w-full cursor-not-allowed" />}
      </div>
      <div className="flex flex-col gap-7">
        <div className="flex items-center gap-2.5">
          <div className="text-sm text-[var(--primary-text)]">
            {t("Automatically assign Project Role to users which fit above criteria")}
          </div>
          <AutoComplete
            options={roleData || []}
            valueField="id"
            getOptionLabel={(option: any) => option?.frontendName || ""}
            value={roleData?.find((opt: any) => opt.id === selectedRole) || null}
            onChange={(_event: any, newValue: any) => handleRuleChange({ value: newValue?.id, itemData: newValue })}
            renderInput={(params: any) => (
              <TextFieldComponent {...params} placeholder={t("Users Role")} style={{ width: "8.75rem" }} />
            )}
          />
        </div>
        <div className="flex items-center gap-2.5">
          <span className="text-sm text-[var(--primary-text)]">
            {t("Automatically keep the Project Role updated as")}{" "}
            <span className="text-sm font-bold">{selectedRoleName()}</span> {t("for these users")}
          </span>
          <ToggleSwitchComponent onChange={handleKeepUserToggle} checked={keepProjectRole} disabled={defaultRule} />
        </div>
        <div className="flex items-center gap-2.5">
          <div className="text-sm text-[var(--primary-text)]">
            {t("Automatically remove users which do not match the above criteria")}
          </div>
          <ToggleSwitchComponent onChange={handleRemoveUserToggle} checked={removeUser} disabled={defaultRule} />
        </div>
      </div>
    </div>
  );

  return (
    <ModalStateDialogComponent
      onCancel={closeModalPopup}
      footerContent={
        <div className="flex gap-4">
          {defaultRule && (
            <ButtonComponent onClick={handleBackClick} buttonType={BUTTON_TYPES.BORDER_BUTTON}>
              {t("Back")}
            </ButtonComponent>
          )}
          <ButtonComponent
            onClick={handlePopUpAction}
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            disabled={!((ruleName || defaultRule) && selectedRole && ruleAdded)}
          >
            {t("Save")}
          </ButtonComponent>
        </div>
      }
      headerTitle={
        <div className="flex h-18 w-full items-center justify-between text-[1.75rem] font-[var(--font-weight-bold)]">
          <span>{!data.length ? t("Add Users By Rule") : t("Edit Rule")}</span>
        </div>
      }
      modelContent={modelContentData()}
      isVisible
      width="60%"
      allowModalPadding={false}
    />
  );
}

export default AddRule;
